import React, { useState, useEffect } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const EditUserPopup = ({
    data,
    type = "add",
    updateUser,
    addUser,
    updateError,
    closePopup,
}) => {
    const [user, setUser] = useState({
        id: data?.user?._id || "",
        name: data?.user?.name || "",
        email: data?.user?.email || "",
        role: data?.user?.role || '',
        password: data?.user?.password || "",
    });

    const [fieldErrors, setFieldErrors] = useState({}); 

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUser((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        const apiCall =
            type === "update"
                ? apiInstance.put(`/devadmin/user/${user.id}`, user)
                : apiInstance.post(`/devadmin/user`, user);

        apiCall
            .then((response) => {
                const returnedUser = response.data.user;
                if (type === "update") {
                    updateUser(returnedUser);
                } else {
                    addUser(returnedUser);
                }
                closePopup();
            })
            .catch((error) => {
                console.log(error)
                if (error.response) {
                    if (
                        error.response.status === 400 &&
                        error.response.data.fieldErrors
                    ) {
                        setFieldErrors(error.response.data.fieldErrors);
                    } else {
                        updateError(error.response.data.message || 'Something went wrong, please try again later.');
                    }
                }
            });
    };

    return (
        <div className="mjsdev-pp">
            <h2>{type === "add" ? "ADD USER" : "EDIT USER"}</h2>

            <form>
                <div className="mjsdev-input-field">
                    <label htmlFor="name">User Name</label>
                    <input
                        type="text"
                        placeholder="User Name"
                        name="name"
                        value={user.name}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.name && (
                        <span className="mjsdev-error">{fieldErrors.name}</span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        placeholder="Email"
                        name="email"
                        value={user.email}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.email && (
                        <span className="mjsdev-error">
                            {fieldErrors.email}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="role">Role</label>
                    <select
                        name="role"
                        value={user.role}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Role</option>
                        <option value="admin">Administrator</option>
                        <option value="Customer">Customer</option>
                        
                    </select>
                    {fieldErrors.role && (
                        <span className="mjsdev-error">
                            {fieldErrors.role}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="password">Password</label>
                    <input
                        type="text"
                        placeholder="Password"
                        name="password"
                        value={user.password}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.password && (
                        <span className="mjsdev-error">
                            {fieldErrors.password}
                        </span>
                    )}
                </div>

            </form>

            <div className="mjsdev-pp-actions">
                <Button
                    name={type === "add" ? "Add" : "Update"}
                    eventHandler={handleSubmit}
                />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
            
        </div>
    );
};

export default EditUserPopup;
